/* ─────────────────────────────────────────
   Start scripts log
───────────────────────────────────────── */

console.log("[custom-events] loaded", new Date().toISOString());

/* ─────────────────────────────────────────
   Close gift message on calendar open
───────────────────────────────────────── */
;(() => {

  function closeGiftAccordion(e) {
    const calendar = document.querySelector('#cc-calendar-overall');
    const giftAccordion = document.querySelector('.cart-note details');
    if (!calendar || !giftAccordion) return;

    if (calendar.contains(e.target)) {
      giftAccordion.removeAttribute('open');
    }
  }

  document.addEventListener('click', closeGiftAccordion);
  document.addEventListener('focusin', closeGiftAccordion);

})();

/* ─────────────────────────────────────────
   Add sitemap link to footer popover
───────────────────────────────────────── */
(function () {
  function addSitemapToPopover() {
    const popover = document.querySelector(
      'anchored-popover-component .terms-policies-popover'
    )
    if (!popover) return

    const list = popover.querySelector('ul.policy_list')
    if (!list || list.querySelector('[data-sitemap-link]')) return

    const li = document.createElement('li')
    const a = document.createElement('a')
    a.href = '/pages/site-map'
    a.className = 'footer-utilities__text'
    a.textContent = 'Sitemap'
    a.dataset.sitemapLink = 'true'

    li.appendChild(a)
    list.appendChild(li)
  }

  document.addEventListener('DOMContentLoaded', addSitemapToPopover)
  document.addEventListener('shopify:section:load', addSitemapToPopover)
})();


/* ─────────────────────────────────────────
   Cart drawer gate
───────────────────────────────────────── */



/* ─────────────────────────────────────────
   End scripts success
───────────────────────────────────────── */
console.log("[custom-events] completed", new Date().toISOString());
;window.Shopify = window.Shopify || {}